module.exports = __webpack_public_path__ + "assets/img/30_783.f677fbdb.jpg";